export function hasHadState(state, report) { 
	return report && report.History && report.History.some(entry => entry.State.Code === state);
}
